import React from 'react';
import { Box, Grid, Typography, Alert } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { format, isToday } from 'date-fns';
import InspectionCard from './InspectionCard';
import { CalendarViewProps } from './types';
import { PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
// Custom day component that displays the inspection count
interface CustomDayProps extends PickersDayProps<Date> {
  inspections?: any[];
}

const CustomDay = (props: CustomDayProps) => {
  const { day, inspections = [], ...other } = props;
  const dateStr = format(day, 'yyyy-MM-dd');
  const todayStr = format(new Date(), 'yyyy-MM-dd');
  const count = inspections.filter(i => i.inspectionDate === dateStr).length;

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <PickersDay
        {...other}
        day={day}
        sx={{
          ...other.sx,
          position: 'relative',
          '&::after': count > 0 ? {
            content: '""',
            display: 'block',
            position: 'absolute',
            bottom: '2px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '60%',
            height: '3px',
            borderRadius: '3px',
            bgcolor: dateStr === todayStr ? 'error.main' : 'primary.main',
          } : {}
        }}
      />
      {count > 0 && (
        <Typography
          variant="caption"
          sx={{
            position: 'absolute',
            top: '-4px',
            right: '-2px',
            bgcolor: dateStr === todayStr ? 'error.main' : 'primary.main',
            color: 'white',
            borderRadius: '50%',
            width: '16px',
            height: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '10px'
          }}
        >
          {count}
        </Typography>
      )}
    </Box>
  );
};

/**
 * CalendarView - Component for displaying inspections in calendar format
 */
const CalendarView: React.FC<CalendarViewProps> = ({
  filteredInspections,
  selectedDate,
  setSelectedDate,
  handleOpenCompletionDialog,
  handleViewDetails,
  handleActionMenuOpen,
  selectedInspection,
  setSelectedInspection,
  handleUpdateStatus,
  inspections,
  handleStartInspection
}) => {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5} lg={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              value={selectedDate}
              onChange={(newDate) => newDate && setSelectedDate(newDate)}
              // renderDay={(day, _value, DayComponentProps) => {
              //   const dateStr = format(day, 'yyyy-MM-dd');
              //   const todayStr = format(new Date(), 'yyyy-MM-dd');
              //   const count = inspections.filter(i => i.inspectionDate === dateStr).length;

              //   // Incorporate the functionality from dayFormatter
              //   // to show the count in the day cell

              //   return (
              //     <Box
              //       sx={{
              //         ...DayComponentProps.sx,
              //         position: 'relative',
              //         '&::after': count > 0 ? {
              //           content: '""',
              //           display: 'block',
              //           position: 'absolute',
              //           bottom: '2px',
              //           left: '50%',
              //           transform: 'translateX(-50%)',
              //           width: '60%',
              //           height: '3px',
              //           borderRadius: '3px',
              //           bgcolor: dateStr === todayStr ? 'error.main' : 'primary.main',
              //         } : {}
              //       }}
              //       {...DayComponentProps}
              //     >
              //       {/* Both content from original day cell and count indicator */}
              //       {day.getDate()}
              //       {count > 0 && (
              //         <Typography
              //           variant="caption"
              //           sx={{
              //             position: 'absolute',
              //             top: '-2px',
              //             right: '-2px',
              //             bgcolor: dateStr === todayStr ? 'error.main' : 'primary.main',
              //             color: 'white',
              //             borderRadius: '50%',
              //             width: '16px',
              //             height: '16px',
              //             display: 'flex',
              //             alignItems: 'center',
              //             justifyContent: 'center',
              //             fontSize: '10px'
              //           }}
              //         >
              //           {count}
              //         </Typography>
              //       )}
              //     </Box>
              //   );
              // }}
              // Use slots instead of renderDay
              slots={{
                day: CustomDay
              }}
              // Pass props to the CustomDay component using callback
              slotProps={{
                day: () => {
                  return {
                    inspections
                  } as any;
                }
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} md={7} lg={8}>
          <Typography variant="h6" gutterBottom>
            Inspections for {format(selectedDate, 'MMMM dd, yyyy')}
            {isToday(selectedDate) && ' (Today)'}
          </Typography>

          {filteredInspections.length === 0 && (
            <Alert severity="info">
              No inspections scheduled for this date.
            </Alert>
          )}

          {filteredInspections.map(inspection => (
            <InspectionCard
              key={inspection.id}
              inspection={inspection}
              handleOpenCompletionDialog={handleOpenCompletionDialog}
              handleViewDetails={handleViewDetails}
              handleActionMenuOpen={handleActionMenuOpen}
              selectedInspection={selectedInspection}
              setSelectedInspection={setSelectedInspection}
              handleUpdateStatus={handleUpdateStatus}
              handleStartInspection={handleStartInspection}
            />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CalendarView;